import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store/store";

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <BrowserRouter>
    <div>
     <App />
    </div>
    </BrowserRouter>
  </Provider>
);

if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register();
}
// else{
//   serviceWorkerRegistration.unregister();
// }
